import React from "react";

interface UpdateRecipeComponentProps {
    onClick: () => void;
    id: string;
    title: string;
    image: string;
    isDeleted: boolean;
}

const UpdateRecipeComponent = ({
    id,
    title,
    image,
    onClick,
    isDeleted,
}: UpdateRecipeComponentProps) => {
    return (
        <div
            className={`p-4rounded-lg w-[325px] h-[325px] my-8 shadow-md cursor-pointer ${isDeleted === true ? 'bg-red-200' : 'bg-gray-100'}`}
            onClick={onClick}>
            <div className="space-y-2">
                <div>
                    <img
                        src={image}
                        alt={title}
                        className="w-full h-48 object-contain rounded-lg"
                    />
                    <p className="text-lg font-semibold text-center mt-4">
                        <strong>Recipe Name: </strong> {title}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UpdateRecipeComponent;
